import { guardId } from '@/api/guardId';
import type { ChatMessage } from '@/api/ChatService';
import { apiFetch } from '@/lib/http';

interface ChatMessagesResponse {
    data: ChatMessage[];
}

/**
 * The conversation the current user is having in this organisation. History
 * lives on the server, so this is what a reloaded page picks up from.
 */
export async function fetchChatMessages(organisationPublicId: string): Promise<ChatMessage[]> {
    guardId(organisationPublicId);

    const response = await apiFetch<ChatMessagesResponse>(`/api/organisations/${organisationPublicId}/chat/messages`);

    return response.data;
}

/**
 * Forget the current conversation so the next question starts a fresh one. The
 * conversation itself is retained server-side; only the pointer to it is cut.
 */
export async function clearChatThread(organisationPublicId: string): Promise<void> {
    guardId(organisationPublicId);

    await apiFetch(`/api/organisations/${organisationPublicId}/chat/thread`, {
        method: 'DELETE',
    });
}
